import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
//import { HeroSection, RelaxationPackage } from './relaxationPackage';
import { RelaxationPackage } from './relaxationPackage';
import { WellnessSection } from './wellnessSection';
import RetreatCouponsSection from './RetreatCouponSection';
//import { WellnessProgramCard } from './wellnessProgramCard';
import WellnessFilterSidebar from "./WellnessFilterSidebar";
import { FeaturesSection } from './featureSection';
import { BookingSection } from './bookingSection';
import { motion } from 'framer-motion';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { KeyUri } from '../key';
import { Sparkles, Star, Leaf, Flower2 } from 'lucide-react';
import { trackEvent } from "../utils/metaPixel";
import SafeImage, { NoImage, pickImage, normalizeImages } from "../Global/SafeTmage";
// src/utils/metaCookies.js
export function getMetaCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}

export function getFbc() {
  let fbc = getMetaCookie("_fbc");
  if (!fbc) {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
      document.cookie = `_fbc=${fbc}; path=/; max-age=${90 * 24 * 60 * 60}`;
    }
  }
  return fbc;
}

// Custom styles for hiding scrollbar
const styles = `
  .scrollbar-hide::-webkit-scrollbar { display: none; }
  .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
  .scroll-container { -webkit-overflow-scrolling: touch; will-change: scroll-position; }
`;

export default function AppJS() {
  const navigate = useNavigate(); 
  const [searchParams, setSearchParams] = useSearchParams();
  const [wellnessPrograms, setWellnessPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Request Callback Modal State
  const [callbackOpen, setCallbackOpen] = useState(false);
  const [callbackProgram, setCallbackProgram] = useState(null);
  const [cbName, setCbName] = useState("");
  const [cbPhone, setCbPhone] = useState("");
  const [cbEmail, setCbEmail] = useState("");
  const [cbTravelDate, setCbTravelDate] = useState("");
  const [cbTravellerCount, setCbTravellerCount] = useState(1);
  const [cbMessage, setCbMessage] = useState("");
const [scrollState, setScrollState] = useState({});

const [priceRange, setPriceRange] = useState([
  Number(searchParams.get("minPrice")) || 0,
  Number(searchParams.get("maxPrice")) || 5000000,
]);

const [selectedLocations, setSelectedLocations] = useState(
  searchParams.get("locations")
    ? searchParams.get("locations").split(",")
    : []
);

const [selectedCategories, setSelectedCategories] = useState(
  searchParams.get("categories")
    ? searchParams.get("categories").split(",")
    : []
);

const [selectedDuration, setSelectedDuration] = useState(
  searchParams.get("duration")
    ? searchParams.get("duration").split(",")
    : []
);

const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

const [showFloatingFilter, setShowFloatingFilter] = useState(false);

useEffect(() => {
  const params = {};

  if (priceRange[0] > 0) {
    params.minPrice = priceRange[0];
  }

  if (priceRange[1] < 5000000) {
    params.maxPrice = priceRange[1];
  }

  if (selectedLocations.length > 0) {
    params.locations = selectedLocations.join(",");
  }

  if (selectedCategories.length > 0) {
    params.categories = selectedCategories.join(",");
  }

  if (selectedDuration.length > 0) {
    params.duration = selectedDuration.join(",");
  }

  setSearchParams(params, { replace: true });
}, [
  priceRange,
  selectedLocations,
  selectedCategories,
  selectedDuration,
  setSearchParams,
]);

useEffect(() => {
  const section = document.getElementById('wellness-programs');
  if (!section) return;

  const observer = new IntersectionObserver(
    ([entry]) => setShowFloatingFilter(entry.isIntersecting),
    {
      threshold: 0,
      rootMargin: '0px 0px -100px 0px', 
    }
  );

  observer.observe(section);
  return () => observer.disconnect();
}, []);

const handleScroll = (index, container) => {
  if (!container) return;

  // Debounce using requestAnimationFrame
  if (container._scrollRaf) cancelAnimationFrame(container._scrollRaf);
  container._scrollRaf = requestAnimationFrame(() => {
    const canScroll = container.scrollWidth > container.clientWidth;
    const left = canScroll && container.scrollLeft > 5;
    const right = canScroll && container.scrollLeft + container.clientWidth < container.scrollWidth - 5;

    setScrollState(prev => {
      const prevState = prev[index] || {};
      if (prevState.canScroll === canScroll && prevState.left === left && prevState.right === right) {
        return prev;
      }
      return { ...prev, [index]: { canScroll, left, right } };
    });
  });
};

// Add onScroll listener to container

  useEffect(() => {
    const fetchWellnessPrograms = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${KeyUri.BACKEND_URI}/wellness-packages`);

          console.log("ALL PROGRAMS:", response.data);

    response.data.forEach(program => {
      console.log(
        "TITLE:", program.title,
        "| AVAILABLE:", program.available,
        "| TYPE:", typeof program.available
      );
    });
        // Sort by order field if available, then by featured
      const filteredPrograms = response.data
  .filter(program => program.available === true)
  .sort((a, b) => {
    if (a.order !== b.order) return a.order - b.order;
    if (a.featured && !b.featured) return -1;
    if (!a.featured && b.featured) return 1;
    return 0;
  });

        setWellnessPrograms(filteredPrograms);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch wellness programs:', err);
        setError('Failed to load wellness programs. Please try again later.');
        setWellnessPrograms([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWellnessPrograms();
  }, []);

  useEffect(() => {
  if (!wellnessPrograms.length) return;

  setTimeout(() => {
    Object.keys(
      wellnessPrograms.reduce((acc, program) => {
        const cat = program.category || "Other";
        acc[cat] = true;
        return acc;
      }, {})
    ).forEach((_, index) => {
      const container = document.getElementById(`category-${index}`);
      if (container) handleScroll(index, container);
    });
  }, 200);
}, [wellnessPrograms]);


  const openCallbackModal = (program) => {
    setCallbackProgram(program);
    setCallbackOpen(true);
  };

  const closeCallbackModal = () => {
    setCallbackOpen(false);
    setCallbackProgram(null);
    setCbName("");
    setCbPhone("");
    setCbEmail("");
    setCbTravelDate("");
    setCbTravellerCount(1);
    setCbMessage("");
  };

  const handleCallbackSubmit = async (e) => {
    e.preventDefault();
    if (!cbName || !cbPhone || !cbEmail) {
      alert("Please fill all required fields");
      return;
    }

    try {
      const response = await axios.post(`${KeyUri.BACKEND_URI}/wellness-bookings`, {
        firstName: cbName.split(' ')[0],
        lastName: cbName.split(' ').slice(1).join(' ') || '',
        email: cbEmail,
        phone: cbPhone,
        wellnessProgram: callbackProgram?._id,
        preferredDate: cbTravelDate,
        guests: cbTravellerCount,
        fbp: getMetaCookie("_fbp"),   
      fbc: getFbc(), 
      });

       trackEvent(
      "Lead",
      {
        content_name: "wellness_callback_request",
        content_category: callbackProgram?.title || "wellness",
        value: 0,
        currency: "INR",
      },
      response.data.eventId 
    );
    
      alert("Thank you! We'll contact you soon.");
      closeCallbackModal();
    } catch (error) {
      console.error('Callback submission error:', error);
      alert("Failed to submit request. Please try again.");
    }
  };

  const toggleArrayFilter = (value, selectedValues, setSelectedValues) => {
  if (selectedValues.includes(value)) {
    setSelectedValues(selectedValues.filter((item) => item !== value));
  } else {
    setSelectedValues([...selectedValues, value]);
  }
};

const handleClearAllFilters = () => {
  setPriceRange([0, 5000000]);
  setSelectedLocations([]);
  setSelectedCategories([]);
  setSelectedDuration([]);

  setSearchParams({});
};

  const openWhatsApp = (program) => {
    const msg = encodeURIComponent(
      `Hello,\n\n` +
      `I am interested in the following wellness package:\n` +
      `• Program: ${program.title}\n` +
      `• Duration: ${program.duration}\n\n` +
      `Could you please share more details and the booking process?\n\n` +
      `Thank you.`
    );
    const phone = "919883587965";
    window.open(`https://wa.me/${phone}?text=${msg}`, "_blank");
  };

const locationOptions = [
  ...new Set(
    wellnessPrograms
      .map((program) => program.location?.city) 
      .filter(Boolean)
  ),
];

const categoryOptions = [
  ...new Set(wellnessPrograms.map((program) => program.category || "Other")),
];

const filteredPrograms = wellnessPrograms.filter((program) => {
   console.log(
    "FILTER CHECK:",
    program.title,
    "| PRICE:",
    program.starting_program_price,
    "| FINAL:",
    Number(program.starting_program_price || 0)
  );
  const location = program.location?.city || "";
  const category = program.category || "Other";
  const price = Number(program.starting_program_price || 0);
  const durationText = program.duration || "";

  const durationDays = parseInt(durationText);

  const matchesPrice = price >= priceRange[0] && price <= priceRange[1];

  const matchesLocation =
    selectedLocations.length === 0 || selectedLocations.includes(location);

  const matchesCategory =
    selectedCategories.length === 0 || selectedCategories.includes(category);

  const matchesDuration =
    selectedDuration.length === 0 ||
    selectedDuration.some((selected) => {
      if (selected === "1-3") return durationDays >= 1 && durationDays <= 3;
      if (selected === "4-7") return durationDays >= 4 && durationDays <= 7;
      if (selected === "8-10") return durationDays >= 8 && durationDays <= 10;
      if (selected === "10+") return durationDays >= 10;
      return false;
    });

  return matchesPrice && matchesLocation && matchesCategory && matchesDuration;
});

  return (
    <>
      <style>{styles}</style>
      <div className="min-h-screen bg-white overflow-x-hidden w-full">
      
        <RelaxationPackage />

    

 <RetreatCouponsSection />

        <section id="wellness-programs" className="py-24 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Heading */}
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <div className="inline-block px-6 py-3 bg-gradient-to-r from-emerald-100 to-teal-100 text-emerald-800 rounded-full mb-6">
        Curated Wellness Programs
      </div>
      <h2 className="mb-4 bg-gradient-to-r from-emerald-700 to-teal-700 bg-clip-text text-transparent">
        Choose Your Healing Path
      </h2>
      <p className="text-gray-700 max-w-3xl mx-auto text-lg">
        Each program is expertly designed to guide you through a transformative journey.
      </p>
    </motion.div>
{/* Desktop: sticky filter bar */}
<div className="hidden md:block mb-10 sticky top-20 z-30 bg-white py-4 px-4">
  <WellnessFilterSidebar
    priceRange={priceRange}
    onPriceChange={setPriceRange}
    selectedLocations={selectedLocations}
    onLocationChange={(loc) => toggleArrayFilter(loc, selectedLocations, setSelectedLocations)}
    selectedCategories={selectedCategories}
    onCategoryChange={(cat) => toggleArrayFilter(cat, selectedCategories, setSelectedCategories)}
    selectedDuration={selectedDuration}
    onDurationChange={(dur) => toggleArrayFilter(dur, selectedDuration, setSelectedDuration)}
    onClearAll={handleClearAllFilters}
    locationOptions={locationOptions}
    categoryOptions={categoryOptions}
  />
</div>

    {/* Loading */}
    {loading && (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-emerald-600"></div>
      </div>
    )}

    {/* Error */}
    {error && !loading && (
      <div className="text-center py-20">
        <p className="text-red-600 text-lg mb-4">{error}</p>
        <Button
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{
            background: 'linear-gradient(to right, #047857, #14b8a6)',
          }}
        >
          Retry
        </Button>
      </div>
    )}

    {/* ✅ PROGRAMS */}
    {!loading && !error && filteredPrograms.length > 0 && (() => {

      const programsByCategory = filteredPrograms.reduce((acc, program) => {
        const category = program.category || 'Other';
        if (!acc[category]) acc[category] = [];
        acc[category].push(program);
        return acc;
      }, {});

      return (
        <div className="space-y-12">
          {Object.entries(programsByCategory).map(([category, programs], catIndex) => (
            <div key={category} className="space-y-4">

              {/* Category Title */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
              >
                <h3 className="text-2xl font-bold text-gray-900 capitalize mb-2">
                  {category}
                </h3>
                <div className="w-16 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full"></div>
              </motion.div>

              {/* Horizontal Scroll Cards */}
              <div className="relative">

                {/* Left Arrow */}
                {scrollState[catIndex]?.left && (
                  <button
                    onClick={() => {
                      const container = document.getElementById(`category-${catIndex}`);
                      container.scrollBy({ left: -320, behavior: 'smooth' });
                      //setTimeout(() => handleScroll(catIndex, container), 200);
                    }}
                    className="absolute left-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white rounded-full shadow-md"
                  >
                    ‹
                  </button>
                )}

                {/* Right Arrow */}
                {scrollState[catIndex]?.right && (
                  <button
                    onClick={() => {
                      const container = document.getElementById(`category-${catIndex}`);
                      container.scrollBy({ left: 320, behavior: 'smooth' });
                     // setTimeout(() => handleScroll(catIndex, container), 200);
                    }}
                    className="absolute right-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white rounded-full shadow-md"
                  >
                    ›
                  </button>
                )}

                {/* Cards */}
                <div
                  id={`category-${catIndex}`}
                  className="flex gap-6 overflow-x-auto pb-4 pt-2 scrollbar-hide scroll-container"
                  onScroll={(e) => handleScroll(catIndex, e.target)}
                >
                  {programs.map((program, index) => (
                    <div
                      key={program._id || index}
                      className="flex-none w-[280px] sm:w-[320px] md:w-[350px]"
                    >
                      <WellnessProgramCard
                        {...program}
                        index={index}
                        onWhatsApp={() => openWhatsApp(program)}
                        onRequestCallback={() => openCallbackModal(program)}
                      />
                    </div>
                  ))}
                </div>

              </div>
            </div>
          ))}
        </div>
      );
    })()}

    {/* Empty */}
    {!loading && !error && filteredPrograms.length === 0 && (
      <div className="text-center py-20">
        <p className="text-gray-600 text-lg">
          No programs match your filters.
        </p>
      </div>
    )}

  </div>
</section>

 <div className="md:hidden flex justify-center pb-4 bg-white">
  <motion.button
    onClick={() => navigate('/wellnessinfopage')}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    className="flex items-center gap-2 px-6 py-3 bg-emerald-700 text-white rounded-lg shadow-md text-sm font-semibold"
  >
    <Sparkles size={16} />
    Corporate Programs
  </motion.button>
</div>

     <WellnessSection />
      <FeaturesSection />

    
      <section className="py-24 bg-gradient-to-b from-white to-emerald-50/30 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="mb-4 bg-gradient-to-r from-emerald-700 to-teal-700 bg-clip-text text-transparent">
              Your Wellness Journey
            </h2>
            <p className="text-gray-700 max-w-2xl mx-auto text-lg">
              From arrival to transformation, experience a carefully curated journey of healing
            </p>
          </motion.div>

          <div className="relative">
           
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-emerald-300 to-teal-300 hidden lg:block" />

            <div className="space-y-12">
              {[
                {
                  phase: 'Day 1-3',
                  title: 'Arrival & Grounding',
                  description: 'Settle into your mountain sanctuary, meet your wellness team, and begin gentle practices to release tension and open to healing.',
                  icon: '🏔️',
                },
                {
                  phase: 'Day 4-7',
                  title: 'Deep Cleansing',
                  description: 'Intensive detox through meditation, yoga, forest bathing, and plant-based nutrition. Release physical and emotional toxins.',
                  icon: '🌿',
                },
                {
                  phase: 'Day 8-14',
                  title: 'Profound Healing',
                  description: 'Advanced mindfulness practices, therapeutic sessions, and sacred ceremonies facilitate deep transformation and renewal.',
                  icon: '✨',
                },
                {
                  phase: 'Day 15+',
                  title: 'Integration & Rebirth',
                  description: 'Learn tools to maintain your transformation, set intentions for the future, and emerge as your renewed self.',
                  icon: '🦋',
                },
              ].map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className={`flex items-center gap-8 ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                    <div className="bg-white rounded-2xl p-8 shadow-lg">
                      <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full mb-4">
                        {step.phase}
                      </div>
                      <h3 className="mb-3 text-gray-900">{step.title}</h3>
                      <p className="text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                  
                
                  <div className="hidden lg:flex items-center justify-center w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full text-3xl shadow-lg relative z-10">
                    {step.icon}
                  </div>
                  
                  <div className="flex-1 hidden lg:block" />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

<div id="booking" className="relative overflow-hidden">
  <BookingSection />
</div>


 

   
<section className="py-24 bg-gradient-to-r from-emerald-600 via-teal-600 to-green-600 relative overflow-hidden">
  <motion.div
    className="absolute inset-0 opacity-20"
    animate={{
      backgroundPosition: ['0% 0%', '100% 100%'],
    }}
    transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse',
    }}
    style={{
      backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
      backgroundSize: '50px 50px',
    }}
  />

  <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-white mb-6">
        Your Transformation Awaits
      </h2>
      <p className="text-emerald-50 text-xl mb-10 leading-relaxed">
        The mountains are calling. The forest is ready to embrace you. Your journey to deep healing, 
        profound peace, and complete renewal begins with a single step. Will you answer the call?
      </p>
      <motion.div
        className="flex flex-wrap gap-6 justify-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
      <motion.button
  onClick={() => {
    document.getElementById('wellness-programs').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }}
  whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)" }}
  whileTap={{ scale: 0.95 }}
  className="px-10 py-5 bg-white text-emerald-700 rounded-full shadow-2xl hover:bg-emerald-50 transition-colors"
>
  Begin Your Journey Today
</motion.button>

        <motion.button
          onClick={() => {
            document.getElementById('booking').scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-10 py-5 border-2 border-white text-white rounded-full hover:bg-white/10 backdrop-blur-sm transition-colors"
        >
          Schedule Free Consultation
        </motion.button>
      </motion.div>
    </motion.div>
  </div>
</section>


{/* Mobile: Floating Filter Button */}
<div className="md:hidden">
  {/* Floating Pill */}
    {showFloatingFilter && (
  <button
    onClick={() => setMobileFilterOpen(true)}
    className="fixed bottom-14 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-5 py-3 rounded-full shadow-xl backdrop-blur-md bg-white/70 border border-emerald-200 text-emerald-800 font-semibold text-sm"
    style={{ boxShadow: '0 8px 32px rgba(16,185,129,0.18)' }}
  >
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h18M6 8h12M9 12h6M11 16h2" />
    </svg>
    Filters
    {(selectedLocations.length + selectedCategories.length + selectedDuration.length) > 0 && (
      <span className="ml-1 bg-emerald-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
        {selectedLocations.length + selectedCategories.length + selectedDuration.length}
      </span>
    )}
  </button>
    )}
  {/* Backdrop */}
  {mobileFilterOpen && (
    <div
      className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
      onClick={() => setMobileFilterOpen(false)}
    />
  )}

  {/* Slide-up Drawer */}
  <div
    className={`fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl transition-transform duration-300 ease-in-out ${
      mobileFilterOpen ? 'translate-y-0' : 'translate-y-full'
    }`}
    style={{ maxHeight: '85vh', overflowY: 'auto' }}
  >
    <div className="flex justify-center pt-3 pb-1">
      <div className="w-10 h-1 rounded-full bg-gray-300" />
    </div>

    <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
      <span className="text-gray-900 font-bold text-lg">Filters</span>
      <div className="flex items-center gap-3">
        <button onClick={handleClearAllFilters} className="text-emerald-600 text-sm font-medium">
          Clear all
        </button>
        <button onClick={() => setMobileFilterOpen(false)} className="text-gray-500 text-2xl font-bold leading-none">
          ×
        </button>
      </div>
    </div>

    <div className="px-5 py-4">
      <WellnessFilterSidebar
        priceRange={priceRange}
        onPriceChange={setPriceRange}
        selectedLocations={selectedLocations}
        onLocationChange={(loc) => toggleArrayFilter(loc, selectedLocations, setSelectedLocations)}
        selectedCategories={selectedCategories}
        onCategoryChange={(cat) => toggleArrayFilter(cat, selectedCategories, setSelectedCategories)}
        selectedDuration={selectedDuration}
        onDurationChange={(dur) => toggleArrayFilter(dur, selectedDuration, setSelectedDuration)}
        onClearAll={handleClearAllFilters}
        locationOptions={locationOptions}
        categoryOptions={categoryOptions}
        vertical={true}
      />
    </div>

    <div className="px-5 pb-8 pt-2">
      <button
        onClick={() => setMobileFilterOpen(false)}
        className="w-full py-4 rounded-2xl bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-bold text-base shadow-lg"
      >
        Show Results ({filteredPrograms.length})
      </button>
    </div>
  </div>
</div>

     
      {callbackOpen && callbackProgram && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/40">
          <div className="relative bg-white w-full md:max-w-xl max-h-[90vh] rounded-t-2xl md:rounded-2xl shadow-2xl overflow-y-auto">
         
            <button
              onClick={closeCallbackModal}
              className="absolute right-3 top-3 text-gray-500 hover:text-gray-700 text-2xl font-bold leading-none z-10"
            >
              ×
            </button>

          
            <div className="px-4 pt-4 pb-3 flex items-start gap-3 border-b border-gray-100">
            <div className="w-14 h-14 rounded-md overflow-hidden flex-shrink-0">
  <SafeImage src={pickImage(callbackProgram.image)} type="wellness" alt={callbackProgram.title} compact />
</div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-800 line-clamp-2">
                  {callbackProgram.title}
                </p>
                <p className="text-xs text-gray-600 mt-1">{callbackProgram.duration}</p>
                {callbackProgram.display_price
 && (
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-base font-bold text-emerald-600">
                      ₹{Number(callbackProgram.display_price
).toLocaleString("en-IN")}
                    </span>
                 {callbackProgram.original_price && 
 callbackProgram.original_price > callbackProgram.display_price && (
  <span className="text-xs text-gray-400 line-through">
    ₹{Number(callbackProgram.original_price).toLocaleString("en-IN")}
  </span>
)}
                  </div>
                )}
              </div>
            </div>

        
            <form onSubmit={handleCallbackSubmit} className="px-4 pb-4 pt-2 space-y-3">
              <TextField
                label="Full Name"
                variant="outlined"
                fullWidth
                required
                value={cbName}
                onChange={(e) => setCbName(e.target.value)}
                size="small"
              />

              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                required
                type="email"
                value={cbEmail}
                onChange={(e) => setCbEmail(e.target.value)}
                size="small"
              />

              <div className="grid grid-cols-4 gap-2">
                <TextField
                  select
                  value="+91"
                  size="small"
                  disabled
                  fullWidth
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="+91">+91</option>
                </TextField>

                <TextField
                  label="Your Phone"
                  variant="outlined"
                  fullWidth
                  required
                  type="tel"
                  size="small"
                  value={cbPhone}
                  onChange={(e) => setCbPhone(e.target.value)}
                  className="col-span-3"
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                <TextField
                  label="Travel Date"
                  type="date"
                  fullWidth
                  required
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={cbTravelDate}
                  onChange={(e) => setCbTravelDate(e.target.value)}
                />
                <TextField
                  label="Guests"
                  type="number"
                  fullWidth
                  required
                  size="small"
                  inputProps={{ min: 1 }}
                  value={cbTravellerCount}
                  onChange={(e) => setCbTravellerCount(e.target.value)}
                />
              </div>

              <TextField
                label="Message"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                size="small"
                value={cbMessage}
                onChange={(e) => setCbMessage(e.target.value)}
                placeholder="Share your requirements or questions..."
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 1,
                  mb: 1,
                  py: 1.5,
                  background: 'linear-gradient(to right, #047857, #14b8a6)',
                  '&:hover': {
                    background: 'linear-gradient(to right, #065f46, #0d9488)',
                  },
                }}
              >
                Connect with an Expert
              </Button>
            </form>
          </div>
        </div>
      )}
      </div>
    </>
  );
}

// WellnessProgramCard component
export function WellnessProgramCard({
  _id, title, duration, description, image, images = [],
  benefits = [],
  activities = [],
  starting_program_price,
  starting_original_price,
  lowest_stay_price,
  lowest_transport_price,
  stay_policy,
  travel_policy,
  featured = false,
  onWhatsApp, onRequestCallback
}) {
  const navigate = useNavigate();
  const detailsHref = _id ? `/wellness/${_id}` : undefined;

  const goToDetails = () => {
    if (!_id) return;
    navigate(`/wellness/${_id}`);
  };

  const handleCardLinkClick = (e) => {
    if (!_id) { e.preventDefault(); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    e.preventDefault();
    goToDetails();
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [descOpen, setDescOpen] = useState(false);

  const allImages = React.useMemo(
    () => [...new Set([...normalizeImages(image), ...normalizeImages(images)])],
    [image, images]
  );
  const hasMultipleImages = allImages.length > 1;

  // Accept plain strings or objects like { name } / { title }
  const toLabel = (item) =>
    typeof item === 'string' ? item : item?.name || item?.title || '';
  const highlightList = (Array.isArray(benefits) ? benefits : []).map(toLabel).filter(Boolean);
  const activityList = (Array.isArray(activities) ? activities : []).map(toLabel).filter(Boolean);

  const plainDescription = (description || '').replace(/<[^>]*>/g, '').trim();
  const isLongDescription = plainDescription.length > 110;

  const inclusionText =
    stay_policy === 'mandatory' && travel_policy === 'mandatory'
      ? 'Incl. stay & transport'
      : stay_policy === 'mandatory'
      ? 'Incl. stay'
      : travel_policy === 'mandatory' && lowest_transport_price > 0
      ? 'Incl. transport'
      : lowest_stay_price > 0
      ? `Stay from ₹${Number(lowest_stay_price).toLocaleString('en-IN')}`
      : null;

  const MAX_CHIPS = 3;

  return (
   
   <div
      className={`group relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col ${
        featured ? 'ring-4 ring-emerald-500/50' : ''
      }`}
    >
    
       <a href={detailsHref}
        onClick={handleCardLinkClick}
        aria-label={title}
        className="absolute inset-0 z-[1]"
      />

  {/* IMAGE AREA */}
      <div className="relative h-44 flex-shrink-0 overflow-hidden">
        {allImages.length === 0 ? (
          <NoImage type="wellness" />
        ) : (
          <div
            className="flex h-full transition-transform duration-500"
            style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
          >
            {allImages.map((img, idx) => (
              <div key={idx} className="w-full h-full flex-shrink-0">
                <SafeImage src={img} type="wellness" alt={`${title} - ${idx + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        )}

        {allImages.length > 0 && (
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent pointer-events-none" />
        )}

      {/* Most Popular badge */}
{featured && (
  <div className="absolute top-3 right-3 z-10 px-3 py-1 rounded-full bg-emerald-500 text-white text-xs font-semibold shadow-lg pointer-events-none">
    Most Popular
  </div>
)}

        {/* Image arrows */}
        {hasMultipleImages && currentImageIndex > 0 && (
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); setCurrentImageIndex(i => i - 1); }}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/35 hover:bg-black/50 rounded-full flex items-center justify-center z-20 transition-colors"
          >
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        {hasMultipleImages && currentImageIndex < allImages.length - 1 && (
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); setCurrentImageIndex(i => i + 1); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/35 hover:bg-black/50 rounded-full flex items-center justify-center z-20 transition-colors"
          >
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}

        {/* Dots (bottom-right so they don't clash with the badge) */}
        {hasMultipleImages && (
          <div className="absolute bottom-4 right-3 flex gap-1.5 z-10">
            {allImages.map((_, idx) => (
              <button
                key={idx}
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); setCurrentImageIndex(idx); }}
                className={`h-2 rounded-full transition-all ${idx === currentImageIndex ? 'bg-white w-4' : 'bg-white/50 hover:bg-white/80 w-2'}`}
              />
            ))}
          </div>
        )}

        {/* Duration pill */}
        <div className="absolute bottom-3 left-3 px-3 py-1.5 bg-black/40 backdrop-blur-sm rounded-full pointer-events-none">
          <span className="text-white text-sm font-semibold">{duration}</span>
        </div>
      </div>

      {/* CONTENT */}
      <div className="p-5 flex flex-col flex-1 min-h-0">
        <h3 className="text-gray-900 text-lg font-bold leading-tight break-words mb-2">
          {title}
        </h3>

        {/* Description + Read More */}
        <div className="mb-4">
          <div
            className={`text-gray-700 leading-snug text-sm [&_*]:m-0 [&_*]:p-0 ${descOpen ? '' : 'line-clamp-2'}`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {isLongDescription && (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); setDescOpen(o => !o); }}
              className="relative z-10 mt-1 text-sm font-semibold text-gray-900 underline underline-offset-2"
            >
              {descOpen ? 'Show Less' : 'Read More'}
            </button>
          )}
        </div>

        {/* HIGHLIGHTS */}
        {highlightList.length > 0 && (
          <div className="mb-3">
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-500">
              Highlights
            </p>
            <div className="flex flex-wrap gap-2">
              {highlightList.slice(0, MAX_CHIPS).map((item, idx) => (
                <span
                  key={idx}
                  title={item}
                  className="inline-flex items-center gap-1.5 max-w-full px-3 py-1 rounded-full bg-emerald-50 text-emerald-900 text-xs"
                >
                  <Leaf className="w-3.5 h-3.5 flex-shrink-0 text-emerald-600" />
                  <span className="truncate">{item}</span>
                </span>
              ))}
              {highlightList.length > MAX_CHIPS && (
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-medium">
                  +{highlightList.length - MAX_CHIPS} more
                </span>
              )}
            </div>
          </div>
        )}

        {/* ACTIVITIES (only if present) */}
        {activityList.length > 0 && (
          <div className="mb-3">
            <p className="mb-2 flex items-center gap-1.5 text-sm font-semibold text-gray-800">
              Activities <Flower2 className="w-4 h-4 text-emerald-600" />
            </p>
            <div className="flex flex-wrap gap-2">
              {activityList.slice(0, MAX_CHIPS).map((item, idx) => (
                <span
                  key={idx}
                  title={item}
                  className="inline-flex items-center max-w-full px-3 py-1 rounded-full bg-gray-100 text-gray-800 text-xs"
                >
                  <span className="truncate">{item}</span>
                </span>
              ))}
              {activityList.length > MAX_CHIPS && (
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">
                  +{activityList.length - MAX_CHIPS} more
                </span>
              )}
            </div>
          </div>
        )}

        <div className="flex-1" />

        {/* PRICE */}
        <div className="min-h-[4.5rem] mb-4 mt-2">
          {starting_program_price ? (
            <div className="space-y-0.5">
              <span className="block text-xs text-gray-500">Starting from</span>
              <div className="flex items-baseline gap-1">
                <span className="text-2xl font-bold text-emerald-600">
                  ₹{Number(starting_program_price).toLocaleString('en-IN')}
                </span>
                <span className="text-xs font-medium text-gray-500">/ person</span>
              </div>

              {starting_original_price > starting_program_price && (
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-gray-400 line-through">
                    ₹{Number(starting_original_price).toLocaleString('en-IN')}
                  </span>
                  <span className="text-xs bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full font-medium">
                    Save {Math.round(((starting_original_price - starting_program_price) / starting_original_price) * 100)}%
                  </span>
                </div>
              )}

              {inclusionText && (
                <div className="text-xs text-gray-600">{inclusionText}</div>
              )}
            </div>
          ) : (
            <div className="text-gray-500 text-sm h-5 flex items-center">
              Contact for pricing
            </div>
          )}
        </div>

        <div className="flex gap-2">
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); onWhatsApp(); }}
            className="relative z-10 flex items-center justify-center border border-green-500 text-green-600 rounded-lg w-12 h-10 flex-none hover:bg-green-50 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-6 h-6">
              <path fill="#25D366" d="M16.04 3C9.41 3 4 8.41 4 15.04c0 2.64.86 5.09 2.33 7.11L4 29l7.07-2.3a12.02 12.02 0 0 0 4.97 1.06C22.6 27.76 28 22.35 28 15.72 28 9.1 22.66 3 16.04 3z"/>
              <path fill="#FFF" d="M22.3 18.53c-.38-.19-2.24-1.1-2.59-1.23-.35-.13-.6-.19-.86.19-.25.38-.98 1.23-1.2 1.48-.22.25-.44.28-.82.09-.38-.19-1.63-.6-3.1-1.92-1.15-1.03-1.93-2.3-2.16-2.68-.22-.38-.02-.58.17-.77.18-.18.38-.44.57-.66.19-.22.25-.38.38-.63.13-.25.06-.47-.03-.66-.09-.19-.86-2.07-1.18-2.84-.31-.75-.63-.65-.86-.66h-.73c-.25 0-.66.09-1 .44-.35.38-1.32 1.29-1.32 3.15 0 1.85 1.35 3.64 1.54 3.89.19.25 2.65 4.05 6.42 5.68 3.77 1.63 3.77 1.09 4.45 1.02.68-.06 2.24-.91 2.56-1.79.31-.88.31-1.63.22-1.79-.09-.16-.35-.25-.73-.44z"/>
            </svg>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); onRequestCallback(); }}
            className="relative z-10 flex-1 border border-emerald-700/40 bg-emerald-50/50 text-emerald-800 hover:bg-emerald-50 rounded-lg h-10 text-sm font-semibold transition-colors"
          >
            Request Callback
          </button>

          <div
            aria-hidden="true"
            className="flex-1 flex items-center justify-center h-10 bg-emerald-700 text-white rounded-lg text-sm font-semibold group-hover:bg-emerald-800 transition-colors"
          >
            View Details
          </div>
        </div>
      </div>
    </div>
  );
}